/**
 * Mobile drawer: the top-level label is a link, the chevron is the toggle.
 *
 * Tapping "Sovrum" used to expand a second, longer menu. What a shopper almost
 * always wants there is the Sovrum page (Jacob, 2026-09-19), so the label now
 * navigates and only the chevron on the right opens the submenu.
 *
 * WHY THIS NEEDS JAVASCRIPT AT ALL. The anchor has to live inside <summary>,
 * because <details> requires the summary to be its first child and there is
 * nowhere else to put a label. A click inside a summary toggles the details
 * whatever it lands on. Calling preventDefault cancels the toggle -- but it is
 * the same click event the anchor would navigate on, so it cancels that too.
 * Hence: cancel, then navigate by hand.
 *
 * Capture phase, delegated from the document, so it runs before the theme's own
 * drawer handlers and keeps working for markup swapped in by section rendering.
 */
document.addEventListener(
  'click',
  function (event) {
    var link = event.target.closest('summary a[data-jr-drawer-direct]');
    if (!link || !link.href) return;

    // Let the browser handle a modified click: new tab, new window, download.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    // preventDefault alone stops the <details> toggling, but the theme binds
    // its own "open submenu" handler to this same click, so the panel would
    // still slide open for the instant before the page changes.
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    window.location.href = link.href;
  },
  true
);
